import { useEffect, useRef, useState } from "react";
import { styles } from "../../../utils/styles/products-shopping-styles";
import { colors } from "../../../utils/const";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { api } from "@/utils/Axios";
import dynamic from "next/dynamic";
const PageHead = dynamic(() => import("@/components/PageHead"));
import ProductMain from "@/components/products-revamp/product-main";
import DynamicFAQSection from "@/components/DynamicFAQSection";
import StepsRow from "@/components/steps-row";
import GenericSwiper from "@/components/general-swiper";
import CenterTitle from "@/components/center-title";
import { OfferStep } from "@/components/products-revamp/offer-step";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PgWithImgSection from "@/components/products-revamp/pg-with-img-section";
import SectionTopLine from "@/components/section-top-line";
import CustomText from "@/components/text";
import {
  emptyProps,
  getProductPageData,
  getShoppingOffers,
} from "@/services/get-product-data";
import {
  getLocalizedValue,
  getStaticTextByKey,
} from "@/utils/general-functions";
import SplitPgSection from "@/components/products-revamp/split-pg-section";
import { useSplitContentSections } from "@/hooks/product";
import { getProductsText } from "../../../../locales/products";
export default function Index({
  heroData,
  contentWithImageData,
  faqData,
  stepsData,
  plansData,
  whycontactData,
  staticTextData,
  featuresData,
  mainData,
  shoppingOffers,
}) {
  const [offers, setOffers] = useState([]);
  const [exclusives, setExclusives] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [cities, setCities] = useState([]);
  const [cityId, setCityId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");
  const [areas, setAreas] = useState([]);
  const [areaId, setAreaId] = useState("");
  const [selectedAreaId, setSelectedAreaId] = useState("");
  const [loading, setLoading] = useState(false);

  const { t, locale } = useI18n();
  const products = getProductsText(locale);
  const isArabic = locale === "ar";

  useEffect(() => {
    !categories.length &&
      api
        .post(
          `/services/categories/main?lang=${locale === "en" ? "en" : "ar"}`,
          {
            crmId: "6",
          },
        )
        .then(function (response) {
          response.data.shift();
          setCategories(response.data);
        })
        .catch(function (error) {});
    !cities.length &&
      api
        .post(`/services/cities?lang=${locale === "en" ? "en" : "ar"}`)
        .then(function (response) {
          setCities(response.data);
        })
        .then(function (response) {
          setCities(response.data);
        })
        .catch(function (error) {});
    if (cityId) {
      api
        .post(`/services/cities/areas?lang=${locale === "en" ? "en" : "ar"}`, {
          cityId: +cityId,
        })
        .then(function (response) {
          setAreas(response.data);
        })
        .catch(function (error) {});
    }
    if (categoryId && cityId) {
      api
        .post(
          `/services/merchants/search?lang=${locale === "en" ? "en" : "ar"}`,
          {
            productId: "6",
            categoryId: `${categoryId}`,
            cityId: `${cityId}`,
            areaId: `${areaId || "0"}`,
            query: "",
          },
        )
        .then(function (response) {
          if (response.data.merchants.length) {
            setData(response.data.merchants);
          } else {
            setData(["not-initial"]);
          }
          setLoading(false);
        })
        .catch(function (error) {});
    }
  }, [categoryId, cityId, areaId]);
  useEffect(() => {
    api
      .get(`/articles?lang=${locale === "en" ? "en" : "ar"}`)
      .then(function (response) {
        setExclusives(response.data);
        setLoading(false);
      })
      .catch(function (error) {});
    api
      .post(`/services/offers?lang=${locale === "en" ? "en" : "ar"}`, {
        productId: "6",
        language: locale === "en" ? "en" : "ar",
        merchantId: "0",
      })
      .then(function (response) {
        setOffers(
          response.data.map((offer) => {
            return {
              img: offer.Image,
              title: offer.Title,
              role: offer.Description,
              id: offer.id,
              type: "offers",
            };
          }),
        );

        setLoading(false);
      })
      .catch(function (error) {});
  }, []);
  const stepsWithNumber = shoppingOffers[0]?.items?.map((s, idx) => ({
    ...s,
    stepNumber: idx + 1,
  }));
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type !== "CONTACTFH_HEIGHT") return;

      const newHeight = Number(event.data.height);
      const force = event.data?.force;

      if (!Number.isFinite(newHeight) || newHeight <= 0) return;

      setIframeHeight((currentHeight) => {
        if (currentHeight === null) return newHeight;

        if (!force && Math.abs(currentHeight - newHeight) < 20) {
          return currentHeight;
        }

        return newHeight;
      });
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    let resizeTimer;

    const requestIframeHeight = () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        iframeRef.current?.contentWindow?.postMessage(
          {
            type: "REQUEST_CONTACTFH_HEIGHT",
          },
          "*",
        );
      }, 300);
    };

    window.addEventListener("resize", requestIframeHeight);

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener("resize", requestIframeHeight);
    };
  }, []);
  const { fullNavySections, splitSections } =
    useSplitContentSections(contentWithImageData);

  const staticTexts = getStaticTextByKey(staticTextData?.data);

  return (
    <>
      <PageHead
        title={getLocalizedValue(mainData[0], "meta_title", locale)}
        description={getLocalizedValue(mainData[0], "meta_description", locale)}
        scripts={getLocalizedValue(mainData[0], "schema", locale)}
      />

      <Box sx={{ ...styles.container, overflow: "hidden" }}>
        {heroData?.length > 0 && (
          <ProductMain
            heroData={heroData}
            staticTexts={staticTexts}
            onApplyClick={() => {
              const formSection = document.getElementById("apply-form");
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            onExploreMoreClick={() => {
              const formSection = document.getElementById(
                "contact-now-features",
              );
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            imgStyle={{
              mt: { xs: 6, md: 12, lg: 11 },
            }}
            headerH1={true}
            noCalc
          />
        )}

        {fullNavySections?.length > 0 &&
          fullNavySections.map((section, index) => (
            <PgWithImgSection
              key={section.id || index}
              img={section.img}
              alt={section.alt_img}
              title={section.title?.text?.[locale]}
              titleType={section.title?.type}
              paragraph={section.description?.text?.[locale]}
              paragraphType={section.description?.type}
              imgReverse={index === 0 || index === 2 ? false : true}
            />
          ))}
        {splitSections?.length > 0 &&
          splitSections.map((section, index) => (
            <SplitPgSection
              key={section.id || index}
              img={section.img}
              alt={section.alt_img}
              title={section.title?.text?.[locale]}
              titleType={section.title?.type}
              paragraph={section.description?.text?.[locale]}
              paragraphType={section.description?.type}
              bgHeight={{
                xs: "100%",
                md: locale === "ar" ? "50%" : "54%",
              }}
            />
          ))}
        <Box sx={{ position: "relative", bgcolor: colors.white }}>
          <Box
            sx={{ bgcolor: colors.navy, pt: 5 }}
            className="vertical-safe-padding"
          >
            <CenterTitle
              title={shoppingOffers[0]?.title?.text[locale]}
              subtitle={shoppingOffers[0]?.description?.text[locale]}
              withBg
              title_variant={shoppingOffers[0]?.title?.type}
              subtitle_variant={shoppingOffers[0]?.description?.type}
            />
            <GenericSwiper
              {...(!isSmall ? { shrink: true } : {})}
              showNavigation={false}
              spaceBetween={40}
              autoplayDelay={4000}
              locale={locale}
              breakpoints={{
                0: { slidesPerView: 1 },
                600: { slidesPerView: 2 }, // sm
                900: { slidesPerView: "auto" }, // md
              }}
              type="details"
              hasArrows={true}
              arrowColor="white"
              sx={{
                "& .swiper": {
                  width: "100%",
                  direction: locale == "ar" ? "rtl" : "ltr",
                  mt: { xs: "-80px", md: 0 },
                },
                "& .swiper-slide": {
                  width: { md: 520 },
                },
                "& .swiper-button-prev, & .swiper-button-next": {
                  display: "none !important",
                },
                padding: 0,
              }}
              items={stepsWithNumber}
              CardComponent={(stepItem) => {
                const img = stepItem[`img_${locale}`];
                const alt = stepItem[`alt_${locale}`];

                return (
                  <OfferStep
                    stepNumber={stepItem.stepNumber}
                    content={stepItem.title?.text?.[locale]}
                    img={img}
                    alt={alt}
                    isArabic={isArabic}
                  />
                );
              }}
              withSpace
            />
          </Box>
          {/**faq section */}
          {faqData?.length > 0 &&
            faqData.map((section, index) => (
              <DynamicFAQSection
                key={section?.id || index}
                title={
                  staticTexts?.faqs_section_title?.value?.text[locale] || ""
                }
                items={section?.faqs}
                renderHTML={true}
                variantTitle="h2"
                variantQ="h3"
              />
            ))}

          {/**Steps section */}
          {stepsData?.length > 0 &&
            stepsData.map((section, index) => (
              <StepsRow
                key={section.id || index}
                title={section?.title?.text?.[locale]}
                subtitle={section?.description?.text?.[locale]}
                steps={section?.items}
              />
            ))}
        </Box>

        <Box sx={{ bgcolor: colors.navy, overflowX: "hidden" }} id="apply-form">
          <SectionTopLine img="https://contact-app-prod.s3.us-east-2.amazonaws.com/contact.eg/contact-line.svg" />

          <Box className="horizontal-safe-padding vertical-safe-padding">
            <CustomText
              text={products.contact_now_page.cover.title}
              type="xl"
              customStyle={{
                color: colors.dark_yellow,
                fontWeight: "700",
                mb: 1,
                lineHeight: 1,
              }}
              variant="h3"
            />
            <CustomText
              text={products.contact_now_page.cover.description}
              type="l"
              customStyle={{ color: colors.white }}
              variant="h3"
            />
            <Box
              sx={{
                width: "100%",
                height: iframeHeight ? `${iframeHeight}px` : "1000px",
                borderRadius: "24px",
                mt: 5,
                overflow: "hidden",
              }}
            >
              <iframe
                ref={iframeRef}
                src={
                  process.env.NEXT_PUBLIC_MODE === "STAGING"
                    ? `https://ria.contact.eg/Contactfh/?lang=${locale === "ar" ? "ar" : "en"}`
                    : `https://ria.contact.eg/ContactEg/?lang=${locale === "ar" ? "ar" : "en"}`
                }
                width="100%"
                height="100%"
                scrolling="no"
                style={{
                  borderRadius: "24px",
                  border: "none",
                  display: "block",
                  overflow: "hidden",
                }}
                loading="lazy"
              />
            </Box>
          </Box>
        </Box>

        {/* {targetProduct?.hasPlan && (
            <CalcPopup
              open={openCalc}
              onClose={() => setOpenCalc(false)}
              data={data}
              max_amount={targetProduct?.maxLimit}
            />
          )} */}
      </Box>
    </>
  );
}

export async function getServerSideProps() {
  try {
    const data = await getProductPageData("shopping");

    const shoppingOffers = await getShoppingOffers();

    return {
      props: {
        ...data,
        shoppingOffers: shoppingOffers?.shoppingOffers || [],
      },
    };
  } catch {
    return {
      props: {
        ...emptyProps,
        shoppingOffers: [],
      },
    };
  }
}
